import request from "@/utils/request";
const index = {
  // 详情
  cominfodetail(query) {
    return request({
      url: "/zuchecomminfo/detail",
      method: "post",
      params: query
    });
  },
  // 修改
  cominfoedit(query) {
    return request({
      url: "/zuchecomminfo/edit",
      method: "post",
      params: query
    });
  },
};
export default index;
